import { isDefined } from "@clipboard-health/util-ts";
import { SvgIcon } from "@mui/material";
import { type SvgIconProps } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import { APP_V2_APP_EVENTS } from "@src/appV2/lib";
import { useLogEffect } from "@src/appV2/lib/analytics";
import BadgeCheck from "@src/appV2/redesign/assets/icons/badge-check.svg?react";
import BellSolid from "@src/appV2/redesign/assets/icons/bell-solid.svg?react";
import Binoculars from "@src/appV2/redesign/assets/icons/binoculars.svg?react";
import Book from "@src/appV2/redesign/assets/icons/book-1.svg?react";
import Bookmark from "@src/appV2/redesign/assets/icons/bookmark-1.svg?react";
import Briefcase from "@src/appV2/redesign/assets/icons/briefcase.svg?react";
import BriefcaseOutlined from "@src/appV2/redesign/assets/icons/briefcase-outlined.svg?react";
import Building from "@src/appV2/redesign/assets/icons/building.svg?react";
import BuildingThick from "@src/appV2/redesign/assets/icons/building-thick.svg?react";
import Calendar from "@src/appV2/redesign/assets/icons/calendar-3.svg?react";
import CalendarDay from "@src/appV2/redesign/assets/icons/calendar-day.svg?react";
import CaretBottom from "@src/appV2/redesign/assets/icons/caret-bottom.svg?react";
import CaretDoubleLeft from "@src/appV2/redesign/assets/icons/caret-double-left.svg?react";
import CaretDoubleRight from "@src/appV2/redesign/assets/icons/caret-double-right.svg?react";
import CenteredCircle from "@src/appV2/redesign/assets/icons/centered-circle.svg?react";
import ChartLineIncrease from "@src/appV2/redesign/assets/icons/chart-line-increase.svg?react";
import Check from "@src/appV2/redesign/assets/icons/check.svg?react";
import ChevronDown from "@src/appV2/redesign/assets/icons/chevron-down.svg?react";
import ChevronLeft from "@src/appV2/redesign/assets/icons/chevron-left.svg?react";
import ChevronRight from "@src/appV2/redesign/assets/icons/chevron-right.svg?react";
import ChevronUp from "@src/appV2/redesign/assets/icons/chevron-up.svg?react";
import Clock from "@src/appV2/redesign/assets/icons/clock.svg?react";
import ClockBack from "@src/appV2/redesign/assets/icons/clock-back.svg?react";
import ClockOutlined from "@src/appV2/redesign/assets/icons/clock-outlined.svg?react";
import Close from "@src/appV2/redesign/assets/icons/close.svg?react";
import Cogwheel from "@src/appV2/redesign/assets/icons/cogwheel.svg?react";
import CoordinatesPerson from "@src/appV2/redesign/assets/icons/coordinates-person.svg?react";
import Dash from "@src/appV2/redesign/assets/icons/dash.svg?react";
import Dollar from "@src/appV2/redesign/assets/icons/dollar-2.svg?react";
import DoorStraight from "@src/appV2/redesign/assets/icons/door-straight.svg?react";
import Ellipsis from "@src/appV2/redesign/assets/icons/ellipsis.svg?react";
import Files from "@src/appV2/redesign/assets/icons/files.svg?react";
import Filter from "@src/appV2/redesign/assets/icons/filter.svg?react";
import FolderPerson from "@src/appV2/redesign/assets/icons/folder-person.svg?react";
import FolderView from "@src/appV2/redesign/assets/icons/folder-view.svg?react";
import Gauge from "@src/appV2/redesign/assets/icons/gauge.svg?react";
import GpsDisabled from "@src/appV2/redesign/assets/icons/gps-disabled.svg?react";
import Group from "@src/appV2/redesign/assets/icons/group-2.svg?react";
import HouseBuilding from "@src/appV2/redesign/assets/icons/house-building.svg?react";
import HybridView from "@src/appV2/redesign/assets/icons/hybrid-view-1.svg?react";
import Hyperlink from "@src/appV2/redesign/assets/icons/hyperlink.svg?react";
import IdentityCard from "@src/appV2/redesign/assets/icons/identity-card.svg?react";
import Information from "@src/appV2/redesign/assets/icons/information.svg?react";
import InformationCircle from "@src/appV2/redesign/assets/icons/information-circle.svg?react";
import LocationAlt from "@src/appV2/redesign/assets/icons/location-alt.svg?react";
import MagnifyingGlass from "@src/appV2/redesign/assets/icons/magnifying-glass.svg?react";
import MapPin from "@src/appV2/redesign/assets/icons/map-pin.svg?react";
import MapPinFilled from "@src/appV2/redesign/assets/icons/map-pin-filled.svg?react";
import MedalStarAlt from "@src/appV2/redesign/assets/icons/medal-star-alt.svg?react";
import Message from "@src/appV2/redesign/assets/icons/message-3.svg?react";
import Microscope from "@src/appV2/redesign/assets/icons/microscope.svg?react";
import Minus from "@src/appV2/redesign/assets/icons/minus.svg?react";
import MoneyDollar from "@src/appV2/redesign/assets/icons/money-dollar.svg?react";
import NotepadAlt from "@src/appV2/redesign/assets/icons/notepad-alt.svg?react";
import NotepadProblem from "@src/appV2/redesign/assets/icons/notepad-problem.svg?react";
import PadlockLocked from "@src/appV2/redesign/assets/icons/padlock-locked.svg?react";
import PalmDollar from "@src/appV2/redesign/assets/icons/palm-dollar.svg?react";
import Pencil from "@src/appV2/redesign/assets/icons/pencil.svg?react";
import People from "@src/appV2/redesign/assets/icons/people.svg?react";
import PersonMale from "@src/appV2/redesign/assets/icons/person-male.svg?react";
import PersonMaleFormal from "@src/appV2/redesign/assets/icons/person-male-formal.svg?react";
import PersonSuperstar from "@src/appV2/redesign/assets/icons/person-superstar.svg?react";
import Plus from "@src/appV2/redesign/assets/icons/plus.svg?react";
import Profile from "@src/appV2/redesign/assets/icons/profile-2.svg?react";
import QuestionCircle from "@src/appV2/redesign/assets/icons/question-circle.svg?react";
import Replay from "@src/appV2/redesign/assets/icons/replay.svg?react";
import Ribbon from "@src/appV2/redesign/assets/icons/ribbon.svg?react";
import Route from "@src/appV2/redesign/assets/icons/route-2.svg?react";
import SortedAscendingArrows from "@src/appV2/redesign/assets/icons/sorted-ascending-arrows.svg?react";
import SortedDescendingArrows from "@src/appV2/redesign/assets/icons/sorted-descending-arrows.svg?react";
import StackVertical from "@src/appV2/redesign/assets/icons/stack-vertical.svg?react";
import Student from "@src/appV2/redesign/assets/icons/student.svg?react";
import Trash from "@src/appV2/redesign/assets/icons/trash.svg?react";
import TriangleDown from "@src/appV2/redesign/assets/icons/triangle-down.svg?react";
import TrianglesDotsHorizontalCollapse from "@src/appV2/redesign/assets/icons/triangles-dots-horizontal-collapse.svg?react";
import TrianglesDotsHorizontalExpand from "@src/appV2/redesign/assets/icons/triangles-dots-horizontal-expand.svg?react";
import UnsortedArrows from "@src/appV2/redesign/assets/icons/unsorted-arrows.svg?react";
import Variant from "@src/appV2/redesign/assets/icons/variant-10.svg?react";
import Warning from "@src/appV2/redesign/assets/icons/warning.svg?react";
import ClipboardBunnyGold from "@src/appV2/redesign/assets/icons-colored/clipboard-bunny-gold.svg?react";

import { type IconType } from "./Icon.types";

// FIXME: Automatically disabled during ESLint config update
// eslint-disable-next-line no-barrel-files/no-barrel-files, import/max-dependencies
export { type IconType } from "./Icon.types";

export type IconSize = "small" | "medium" | "large";

export const iconMap = {
  "badge-check": BadgeCheck,
  "bell-solid": BellSolid,
  binoculars: Binoculars,
  book: Book,
  bookmark: Bookmark,
  briefcase: Briefcase,
  "briefcase-outlined": BriefcaseOutlined,
  building: Building,
  "building-thick": BuildingThick,
  calendar: Calendar,
  "calendar-day": CalendarDay,
  "caret-bottom": CaretBottom,
  "caret-double-left": CaretDoubleLeft,
  "caret-double-right": CaretDoubleRight,
  "centered-circle": CenteredCircle,
  "chart-line-increase": ChartLineIncrease,
  check: Check,
  "chevron-down": ChevronDown,
  "chevron-left": ChevronLeft,
  "chevron-right": ChevronRight,
  "chevron-up": ChevronUp,
  clock: Clock,
  "clock-back": ClockBack,
  "clock-outlined": ClockOutlined,
  close: Close,
  cogwheel: Cogwheel,
  "coordinates-person": CoordinatesPerson,
  "clipboard-bunny-gold": ClipboardBunnyGold,
  dash: Dash,
  dollar: Dollar,
  "door-straight": DoorStraight,
  ellipsis: Ellipsis,
  files: Files,
  filter: Filter,
  "folder-person": FolderPerson,
  "folder-view": FolderView,
  gauge: Gauge,
  "gps-disabled": GpsDisabled,
  group: Group,
  "house-building": HouseBuilding,
  "hybrid-view": HybridView,
  hyperlink: Hyperlink,
  "identity-card": IdentityCard,
  information: Information,
  "information-circle": InformationCircle,
  "location-alt": LocationAlt,
  "magnifying-glass": MagnifyingGlass,
  "map-pin": MapPin,
  "map-pin-filled": MapPinFilled,
  "medal-star-alt": MedalStarAlt,
  message: Message,
  microscope: Microscope,
  minus: Minus,
  "money-dollar": MoneyDollar,
  "notepad-alt": NotepadAlt,
  "notepad-problem": NotepadProblem,
  "padlock-locked": PadlockLocked,
  "palm-dollar": PalmDollar,
  pencil: Pencil,
  people: People,
  "person-male": PersonMale,
  "person-male-formal": PersonMaleFormal,
  "person-superstar": PersonSuperstar,
  plus: Plus,
  profile: Profile,
  "question-circle": QuestionCircle,
  replay: Replay,
  ribbon: Ribbon,
  route: Route,
  "sorted-ascending-arrows": SortedAscendingArrows,
  "sorted-descending-arrows": SortedDescendingArrows,
  "stack-vertical": StackVertical,
  student: Student,
  trash: Trash,
  "triangle-down": TriangleDown,
  "triangles-dots-horizontal-collapse": TrianglesDotsHorizontalCollapse,
  "triangles-dots-horizontal-expand": TrianglesDotsHorizontalExpand,
  "unsorted-arrows": UnsortedArrows,
  variant: Variant,
  warning: Warning,
} as const satisfies Record<IconType, React.ComponentType>;

export interface IconProps extends Omit<SvgIconProps, "color"> {
  type: IconType;
  size?: IconSize;
  sx?: SvgIconProps["sx"];
}

export function Icon(props: IconProps) {
  const { type, size = "medium", sx, ...restProps } = props;
  const theme = useTheme();

  const IconComponent = iconMap[type];

  useLogEffect(
    APP_V2_APP_EVENTS.NON_EXISTING_ICON_REQUESTED,
    {
      type,
    },
    {
      enabled: !isDefined(IconComponent),
    }
  );

  if (!isDefined(IconComponent)) {
    return null;
  }

  const iconSize = theme.size?.icon[size] ?? "1rem";

  return (
    <SvgIcon
      {...restProps}
      sx={{
        width: iconSize,
        height: iconSize,
        ...sx,
      }}
    >
      <IconComponent />
    </SvgIcon>
  );
}
